var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.operate] || "-",
          backUrl: "/marketing/ads/advList",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "广告名称：", prop: "adName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入广告名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.adName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "adName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.adName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "广告图片：", prop: "adImage" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: { click: _vm.modalPicTap },
                            },
                            [
                              _vm.formValidate.adImage
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formValidate.adImage },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：702*352px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接：", prop: "jumpUrl" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入跳转链接",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.jumpUrl,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "jumpUrl",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.jumpUrl",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启：", prop: "isEnabled" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "是",
                              "inactive-text": "否",
                            },
                            model: {
                              value: _vm.formValidate.isEnabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "isEnabled", $$v)
                              },
                              expression: "formValidate.isEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi([
                    "platform:marketing:ads:adv:save",
                    "platform:marketing:ads:adv:update",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }